module.exports = __webpack_public_path__ + "img/logo1.4e879dd2.png";